import { FunctionComponent } from "react"
import { Table } from "react-bootstrap"
import { KeycardDoorsQuery } from "../hooks/queries/useGetKeycardDoorsQuery"
import FilterField from "./FilterField"

interface IKeycardDoorsTable {
	keycardDoorsQuery: KeycardDoorsQuery
	hideColumns?: {
		entity: boolean
	}
}
const KeycardDoorsTable: FunctionComponent<IKeycardDoorsTable> = ({ keycardDoorsQuery: query, hideColumns }) => {
	if (query.data == null) return null
	const keycardDoors = query.data!.keycardDoors
	return (
		<Table striped bordered hover size="sm">
			<thead>
				<tr>
					{hideColumns?.entity !== true && <th onClick={() => query.sortBy("entityName")}>Cardholder</th>}
					<th onClick={() => query.sortBy("keycard")}>Keycard</th>
					<th onClick={() => query.sortBy("doorName")}>Door</th>
					<th onClick={() => query.sortBy("startDate")}>Start Date</th>
					<th onClick={() => query.sortBy("endDate")}>End Date</th>
					<th onClick={() => query.sortBy("dailyStartTime")}>Start Time</th>
					<th onClick={() => query.sortBy("dailyEndTime")}>End Time</th>
				</tr>
				<tr>
					{hideColumns?.entity !== true && (
						<td>
							<FilterField
								filter={query.entityFilter}
								setFilter={query.setEntityFilter}
								placeholder="Filter Cardholder"
							/>
						</td>
					)}
					<td>
						<FilterField filter={query.keycardFilter} setFilter={query.setKeycardFilter} placeholder="Filter Keycard" />
					</td>
					<td>
						<FilterField filter={query.doorFitler} setFilter={query.setDoorFilter} placeholder="Filter Door" />
					</td>
				</tr>
			</thead>
			<tbody>
				{keycardDoors?.map((keycardDoor) => (
					<tr key={keycardDoor.id}>
						{hideColumns?.entity !== true && <td>{keycardDoor.entityName}</td>}
						<td>{keycardDoor.keycard}</td>
						<td>{keycardDoor.doorName}</td>
						<td>{keycardDoor.startDate}</td>
						<td>{keycardDoor.endDate}</td>
						<td>{keycardDoor.dailyStartTime}</td>
						<td>{keycardDoor.dailyEndTime}</td>
					</tr>
				))}
			</tbody>
		</Table>
	)
}
export default KeycardDoorsTable
